export type AdvisorAbsenceStatus = 'ACTIVE' | 'NEXT' | 'UPCOMING' | 'PAST';

export interface AdvisorAbsence {
  id: number;
  startDate: string; // 'YYYY-MM-DD', inclusive
  endDate: string; // 'YYYY-MM-DD', inclusive
  note: string;
  status: AdvisorAbsenceStatus;
}

export interface AdvisorAbsenceRequest {
  startDate: string; // 'YYYY-MM-DD'
  endDate: string; // 'YYYY-MM-DD'
  note: string;
}
